<button 
  [class]="classe" 
  [disabled]="disabled"
  [ngStyle]="buttonStyles"
  (click)="handleClick()">
  {{ texto }}
</button>

